import { fetchBaseQuery, createApi } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../constants';

// Attach the logged-in user's bearer token (read per-request from localStorage)
// so authenticated/admin endpoints work reliably. Previously the token was read
// once at module load and admin calls sent no Authorization header at all, which
// only "worked" because those endpoints were unauthenticated.
const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  prepareHeaders: (headers) => {
    try {
      const raw = localStorage.getItem('userInfo');
      if (raw) {
        const token = JSON.parse(raw)?.token;
        if (token) headers.set('Authorization', `Bearer ${token}`);
      }
    } catch (e) {
      // ignore malformed userInfo
    }
    headers.set('Accept', 'application/json');
    return headers;
  },
});

export const apiSlice = createApi({
  baseQuery,
  tagTypes: ['Product', 'Order', 'User', 'Fulfillment'],
  endpoints: (builder) => ({}),
});
